import stylisRTL from './stylis-rtl'
import createCache from '@emotion/cache'
import stylisMirror, {
  MIRROR_REGEX,
  STYLIS_PROPERTY_CONTEXT
} from './stylis-mirror'
import {StylisContextType} from './stylis'

// FIXME: won't work with SSR, inject instead
const isRTL =
  typeof document !== 'undefined' &&
  document.documentElement &&
  document.documentElement.getAttribute('dir') === 'rtl'

// Remove /* @mirror */ from output for LTR languages
const dummyMirrorPlugin = (
  context: StylisContextType,
  content: string
): string | null | undefined => {
  if (context === STYLIS_PROPERTY_CONTEXT) {
    return content.replace(MIRROR_REGEX, '')
  }
}

const runCreateCache = isRtl => {
  return createCache({
    stylisPlugins: isRtl ? [stylisRTL, stylisMirror] : [dummyMirrorPlugin]
  })
}

export const evaluateInRuntime = isRtl => {
  return runCreateCache(isRtl)
}

export default runCreateCache(isRTL)
